module.exports = __webpack_public_path__ + "img/jazzy-thumbnail-fallback_with-red-bg.9360652.png";